var StoresListItemModel = Backbone.Epoxy.Model.extend({
  initialize: function() { },

  defaults: {
    id: null,
    name: null,
    address1: null,
    address2: null,
    phone: null
  },

  computeds: { },

  validation: { },

  bindModel: function(data) {
    this.bindingData = true;

    this.set('id', data.id);
    this.set('name', data.name);
    this.set('address1', data.address1);
    this.set('address2', data.address2);
    this.set('phone', data.phone || '');

    this.bindingData = false;
  }

});

module.exports = StoresListItemModel;
